module.exports = __webpack_public_path__ + "static/media/userPlus.b7733776.svg";